/**
 * Shared helpers for the image-upload components (@kardume/ui). Converts a
 * browser File into the base64 payload the Kardume core expects on
 * `POST /v1/merchant/profile/images`.
 */

export interface ImageUploadPayload {
  /** Raw base64 content (no data-URL prefix). */
  base64: string;
  /** MIME type, e.g. "image/png". */
  contentType: string;
  /** File extension without the dot, e.g. "png". */
  extension: string;
  /** Original file name. */
  fileName: string;
}

export const ACCEPTED_IMAGE_TYPES = 'image/png,image/jpeg,image/webp,image/gif';

/** Max accepted image size in bytes (5 MB). */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Reads a File into an {@link ImageUploadPayload} (base64 without the prefix). */
export function readImagePayload(file: File): Promise<ImageUploadPayload> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Não foi possível ler a imagem.'));
    reader.onload = () => {
      const result = String(reader.result || '');
      const commaIndex = result.indexOf(',');
      const base64 = commaIndex >= 0 ? result.slice(commaIndex + 1) : result;
      const contentType = file.type || 'image/png';
      const extension = contentType.split('/').pop() || 'png';
      resolve({ base64, contentType, extension, fileName: file.name });
    };
    reader.readAsDataURL(file);
  });
}
